// @ts-nocheck

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import '../App.css'
import '@fontsource/montserrat';

export const Route = createFileRoute('/')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate();
  navigate({ to: "/visits" });
  
  return <div></div>
}
